/* SBA Collection — drawer, sort, wishlist, active pills, price slider */
(function () {
  'use strict';

  const root = document.querySelector('.sba-coll');
  if (!root) return;

  const $  = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));

  // ---------- DRAWER ----------
  const drawer = $('[data-sba-drawer]');
  function openDrawer(groupLabel) {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (groupLabel) {
      const target = $$('.sba-coll__group', drawer).find(d =>
        (d.getAttribute('data-filter-group') || '').toLowerCase() === groupLabel.toLowerCase()
      );
      if (target) {
        $$('.sba-coll__group', drawer).forEach(d => d.open = false);
        target.open = true;
        setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
      }
    }
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  }
  $$('[data-sba-open-filters]').forEach(b => b.addEventListener('click', () => openDrawer()));
  $$('[data-sba-open-filter]').forEach(b => b.addEventListener('click', () => openDrawer(b.getAttribute('data-sba-open-filter'))));
  $$('[data-sba-close-drawer]').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // ---------- SIZE PILL TOGGLE ----------
  $$('.sba-coll__size').forEach(label => {
    const input = label.querySelector('input');
    if (!input) return;
    const sync = () => label.classList.toggle('is-on', input.checked);
    sync();
    input.addEventListener('change', sync);
  });
  $$('.sba-coll__color').forEach(label => {
    const input = label.querySelector('input');
    if (!input) return;
    const sync = () => label.classList.toggle('is-on', input.checked);
    sync();
    input.addEventListener('change', sync);
  });

  // ---------- SORT (chip opens native select) ----------
  const sortChip = $('[data-sba-toggle-sort]');
  const sortSelect = $('[data-sba-sort-select]');
  if (sortChip && sortSelect) {
    sortChip.addEventListener('click', () => {
      try { sortSelect.showPicker(); } catch (e) { sortSelect.focus(); sortSelect.click(); }
    });
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ---------- ACTIVE PILLS (from URL) ----------
  function buildActivePills() {
    const container = $('[data-sba-active-pills]');
    const containerEmpty = document.querySelector('[data-sba-active-pills-empty]');
    if (!container && !containerEmpty) return;
    const url = new URL(window.location.href);
    const pills = [];
    url.searchParams.forEach((value, key) => {
      if (!key.startsWith('filter.')) return;
      const label = decodeURIComponent(value).replace(/\+/g, ' ');
      pills.push({ key, value, label });
    });
    const html = pills.map(p =>
      '<span class="sba-coll__active-pill" data-key="' + p.key + '" data-value="' + p.value + '">' +
      p.label +
      ' <button type="button" class="sba-coll__active-pill-x" aria-label="Retirer">' +
      '<svg width="11" height="11" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="3" y1="3" x2="11" y2="11"/><line x1="11" y1="3" x2="3" y2="11"/></svg>' +
      '</button></span>'
    ).join('');
    if (container) container.innerHTML = html;
    if (containerEmpty) containerEmpty.innerHTML = html;
    const count = $('[data-sba-active-count]');
    if (count) count.textContent = pills.length ? String(pills.length) : '';
    const clearLink = $('[data-sba-clear-link]');
    if (clearLink) clearLink.hidden = pills.length === 0;
    document.querySelectorAll('.sba-coll__active-pill-x').forEach(btn => {
      btn.addEventListener('click', () => {
        const pill = btn.closest('.sba-coll__active-pill');
        const k = pill.getAttribute('data-key');
        const v = pill.getAttribute('data-value');
        const u = new URL(window.location.href);
        const params = u.searchParams.getAll(k).filter(x => x !== v);
        u.searchParams.delete(k);
        params.forEach(p => u.searchParams.append(k, p));
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }
  buildActivePills();

  // ---------- CLEAR FILTERS ----------
  $$('[data-sba-clear-filters]').forEach(b => b.addEventListener('click', () => {
    const u = new URL(window.location.href);
    Array.from(u.searchParams.keys()).filter(k => k.startsWith('filter.')).forEach(k => u.searchParams.delete(k));
    u.searchParams.delete('page');
    window.location.href = u.toString();
  }));

  // ---------- PRICE DUAL HANDLE ----------
  $$('[data-sba-price]').forEach(el => {
    const rangeMin = Number(el.getAttribute('data-min'));
    const rangeMax = Number(el.getAttribute('data-max'));
    const minInput = el.querySelector('[data-sba-price-input="min"]');
    const maxInput = el.querySelector('[data-sba-price-input="max"]');
    const fill     = el.querySelector('[data-sba-price-fill]');
    const handMin  = el.querySelector('[data-sba-price-handle="min"]');
    const handMax  = el.querySelector('[data-sba-price-handle="max"]');
    const label    = el.querySelector('[data-sba-price-label]');
    const track    = el.querySelector('.sba-coll__price-track');

    function valToPct(v) {
      if (rangeMax === rangeMin) return 0;
      return ((v - rangeMin) / (rangeMax - rangeMin)) * 100;
    }
    function render() {
      const a = Number(minInput.value) || rangeMin;
      const b = Number(maxInput.value) || rangeMax;
      const lo = Math.min(a, b), hi = Math.max(a, b);
      const pLo = valToPct(lo), pHi = valToPct(hi);
      handMin.style.left = pLo + '%';
      handMax.style.left = pHi + '%';
      fill.style.left = pLo + '%';
      fill.style.right = (100 - pHi) + '%';
      if (label) label.textContent = '€' + lo + ' — €' + hi;
    }
    render();
    minInput.addEventListener('input', render);
    maxInput.addEventListener('input', render);

    function drag(handle, which) {
      handle.addEventListener('pointerdown', e => {
        e.preventDefault();
        handle.setPointerCapture(e.pointerId);
        const rect = track.getBoundingClientRect();
        function move(ev) {
          let pct = ((ev.clientX - rect.left) / rect.width);
          pct = Math.max(0, Math.min(1, pct));
          const val = Math.round(rangeMin + pct * (rangeMax - rangeMin));
          if (which === 'min') {
            const other = Number(maxInput.value) || rangeMax;
            minInput.value = Math.min(val, other);
          } else {
            const other = Number(minInput.value) || rangeMin;
            maxInput.value = Math.max(val, other);
          }
          render();
        }
        handle.addEventListener('pointermove', move);
        handle.addEventListener('pointerup', function up(ev) {
          handle.removeEventListener('pointermove', move);
          handle.removeEventListener('pointerup', up);
        }, { once: true });
      });
    }
    drag(handMin, 'min');
    drag(handMax, 'max');

    $$('[data-sba-price-preset]', el).forEach(btn => {
      btn.addEventListener('click', () => {
        const parts = btn.getAttribute('data-sba-price-preset').split(',');
        minInput.value = parts[0];
        maxInput.value = parts[1];
        render();
      });
    });
  });

  // ---------- WISHLIST (localStorage) ----------
  const WL_KEY = 'sba_wishlist';
  function loadWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function applyWishlistState() {
    const list = loadWishlist();
    document.querySelectorAll('[data-sba-card]').forEach(card => {
      const handle = card.getAttribute('data-product-handle');
      const btn = card.querySelector('[data-sba-wishlist]');
      if (btn) btn.setAttribute('aria-pressed', list.includes(handle) ? 'true' : 'false');
    });
  }
  applyWishlistState();
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-sba-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('[data-sba-card]');
    if (!card) return;
    const handle = card.getAttribute('data-product-handle');
    let list = loadWishlist();
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    btn.setAttribute('aria-pressed', list.includes(handle) ? 'true' : 'false');
  });
})();
